import React, {Component} from 'react';
import Competition from './competition';
import Exposure from './exposure';
import UserMessagesDictionary from 'components/organisms/competition-stacking/dictionaries/UserMessagesDictionary';

class StackItem extends Component {
    render() {
        const {competitionType, itemId, children} = this.props;
        return (
            <div className="correlation-rule inline">
                <div className="form-inline">
                    <strong className="form-text">
                        {UserMessagesDictionary.getCompetitionOpponentsTitle(competitionType)}
                    </strong>
                    <Competition itemId={itemId} />
                </div>
                <div className="form-inline">
                    <strong className="form-text">in exactly</strong>
                    <Exposure itemId={itemId} />
                    <strong className="form-text">of lineups</strong>
                </div>
                {children}
            </div>
        );
    }
}

export default StackItem;
